import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@mui/material'
import MainCard from './MainCard'

const AuthCardWrapper = ({ children, ...other }) => (
  <MainCard
    sx={{
      maxWidth: { xs: 500, lg: 575 },
      margin: { xs: 2.5, md: 3 },
      '& > *': {
        flexGrow: 1,
        flexBasis: '50%',
      },
      borderRadius: '14px',
    }}
    content={false}
    {...other}
  >
    <Box sx={{ p: { xs: 2, sm: 3, xl: 5 } }}>{children}</Box>
  </MainCard>
)

AuthCardWrapper.propTypes = {
  children: PropTypes.node,
}

export default AuthCardWrapper
